import { cx } from 'class-variance-authority'

import LoadingSpinner from '../LoadingSpinner/LoadingSpinner'

import css from './Loading.module.css'

type LoadingProps = {
  fullscreen?: boolean
  variant?: 'default' | 'white' | 'black'
}

export default function Loading({ fullscreen = false, variant }: LoadingProps) {
  return (
    <div className={cx(css.loading, { [css.loading_fullscreen]: fullscreen })}>
      <LoadingSpinner variant={variant} />
    </div>
  )
}
